// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2JRan","header":"ClearentDisclaimer_header__2tfxH","inner":"ClearentDisclaimer_inner__2tLlF"};